<div class="TootTiptopSection">
  <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
    <img src="/icons/close-kb.svg" alt="" class="close" width="25" />
  </button>
</div>

<mat-dialog-content class="TootTip-content">
  <form [formGroup]="emailForm">

    <p class="TootTip-tittle">{{'common.value_calculator_proEmail_summary'|cxTranslate}}</p>
    <p class="endaSureDescription">{{'common.value_calculator_contact_info'|cxTranslate}}</p>
    <div class="my-section-box EmailInfo" id="EmailInfo">

      <div class="my-section-box-inner fleet-info-block">
        <div class="row">

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-12">
            <label for="search">{{ 'common.value_calculator_firstName' | cxTranslate }}</label>
            <div class="col-12 px-0">
              <input type="text" formControlName="FName" />
              @if (form.FName.invalid && (form.FName.dirty || form.FName.touched)) {
                <span class="text-danger-show">
                {{'common.value_calculator_fName_emptyMsg'|cxTranslate}}</span>
              }
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-12 mt-4">
            <label for="search">{{ 'common.value_calculator_lastName' | cxTranslate }}</label>
            <div class="col-12 px-0">
              <input type="text" formControlName="LName" />
              @if (form.LName.invalid && (form.LName.dirty || form.LName.touched)) {
                <span class="text-danger-show">
                {{'common.value_calculator_lName_emptyMsg'|cxTranslate}}</span>
              }
            </div>
          </div>


          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-12 mt-4">
            <label for="search">{{ 'common.value_calculator_email_text' | cxTranslate }}</label>
            <div class="col-12 px-0">
              <input type="text" formControlName="emailId" />
              @if (form.emailId.invalid && (form.emailId.dirty || form.emailId.touched)) {
                <span class="text-danger-show"
                  >
                {{'common.value_calculator_email_emptyMsg'|cxTranslate}}</span>
              }
            </div>
          </div>


        </div>

        <div class="col-xs-12 col-sm-12 mt-4">
          <re-captcha id="recaptcha" formControlName="recaptcha" (resolved)="checkCaptcha($event)"
          formControlName="recaptcha" name="recaptcha" required></re-captcha>
          @if (form.recaptcha.invalid && (form.recaptcha.dirty || form.recaptcha.touched)) {
            <span class="text-danger-show"
            >{{'common.general_required'|cxTranslate}}.</span>
          }
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4">
            <button type="button" id="emailSubmit" class="btn" (click)="emailResult()">{{
              'common.value_calculator_email_text' | cxTranslate }}
              <img src="/icons/link-right-white.svg" class="right-arrow" alt=""></button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>